"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = exports.CheckConnection = exports.COWindowComm = void 0;
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _setInterval2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-interval"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var COWindowComm = /*#__PURE__*/function () {
  function COWindowComm(side) {
    var _this = this;
    var childWindowArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var trustedOrigins = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [window.location.origin];
    var targetOrigin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.location.origin;
    (0, _classCallCheck2["default"])(this, COWindowComm);
    this._state = "000";
    this.side = side;
    this.childWindowArgs = childWindowArgs;
    this.trustedOrigins = trustedOrigins;
    this.targetOrigin = targetOrigin;
    if (this.side === "parent") {
      this.parentWindow = window;
      this.childWindow = window.open(this.childWindowArgs.url, this.childWindowArgs.name, this.childWindowArgs.params);
      this.parentWindow.onbeforeunload = function () {
        _this.childWindow.close();
      };
    } else if (this.side === "child") {
      this.parentWindow = window.opener;
      this.childWindow = window;
    }
  }
  (0, _createClass2["default"])(COWindowComm, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "checkOrigin",
    value: function checkOrigin(origin) {
      var _context;
      if ((0, _indexOf["default"])(_context = this.trustedOrigins).call(_context, origin) === -1) {
        throw new Error("CROCOM: \"".concat(origin, "\" is not a trusted origin!"));
      }
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(message) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.targetOrigin;
      var msg = new Message(this._state, message, data);
      if (this.side === "parent") {
        this.childWindow.postMessage(msg, origin);
      } else {
        this.parentWindow.postMessage(msg, origin);
      }
    }
  }, {
    key: "reciveMessageOnce",
    value: function reciveMessageOnce() {
      var handlerOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        once: true
      };
      var _self = this;
      var options = (0, _assign["default"])(handlerOptions, {
        once: true
      });
      return new _promise["default"](function (resolve, reject) {
        window.addEventListener("message", {
          handleEvent: function handleEvent(event) {
            var response = event.data;
            try {
              _self.checkOrigin(event.origin);
              resolve(response);
            } catch (error) {
              reject(error);
            }
          }
        }, options);
      });
    }
  }, {
    key: "reciveMessage",
    value: function reciveMessage() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (res, err) {
        console.log(res, err);
      };
      var handlerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        once: false
      };
      var _self = this;
      var response = null;
      var error = null;
      window.addEventListener("message", {
        handleEvent: function handleEvent(event) {
          response = event.data;
          try {
            _self.checkOrigin(event.origin);
            if (callback) callback(response, error);
          } catch (error) {
            if (callback) callback(response, error);
          }
        }
      }, handlerOptions);
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      var checkConnection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new CheckConnection(1000, this.side === "parent" ? "Child window closed. do you wish to open it again?" : "Parent window closed. This window will be closed too.", function () {});
      return new _promise["default"](function (resolve, reject) {
        if (_this2.side === "parent") {
          _this2.reciveMessageOnce().then(function (response) {
            if (response.status === COWindowComm.INIT_CONNECTION) {
              _this2._state = COWindowComm.CONNECTION_ESTABLISHED;
              _this2.sendMessage("ready");
              _this2.reciveMessageOnce().then(function (response) {
                if (response.status === COWindowComm.OK) {
                  _this2._state = COWindowComm.OK;
                  if (checkConnection) {
                    var checking = (0, _setInterval2["default"])(function () {
                      if (_this2.childWindow.closed) {
                        _this2._state = COWindowComm.CHILD_WINDOW_CLOSED;
                        _this2._state = COWindowComm.NOT_CONNECTED;
                        if (checkConnection.callback) {
                          checkConnection.callback(_this2.parentWindow, _this2.childWindow);
                        }
                        _this2.childWindow.close();
                        _this2.childWindow = null;
                        clearInterval(checking);
                      }
                    }, checkConnection.each);
                  }
                  resolve(_this2._state);
                }
              })["catch"](function (error) {
                reject(error);
              });
            }
          })["catch"](function (error) {
            reject(error);
          });
        } else {
          _this2._state = COWindowComm.INIT_CONNECTION;
          _this2.sendMessage("init");
          _this2.reciveMessageOnce().then(function (response) {
            if (response.status === COWindowComm.CONNECTION_ESTABLISHED) {
              _this2._state = COWindowComm.OK;
              _this2.sendMessage("OK");
              if (checkConnection) {
                var checking = (0, _setInterval2["default"])(function () {
                  if (_this2.parentWindow.closed) {
                    alert(checkConnection.message);
                    _this2.childWindow.close();
                    clearInterval(checking);
                  }
                }, checkConnection.each);
              }
              resolve(_this2._state);
            }
          })["catch"](function (error) {
            reject(error);
          });
        }
      });
    }
  }]);
  return COWindowComm;
}();
exports.COWindowComm = COWindowComm;
COWindowComm.NOT_CONNECTED = "000";
COWindowComm.INIT_CONNECTION = "101";
COWindowComm.CONNECTION_ESTABLISHED = "103";
COWindowComm.OK = "200";
COWindowComm.CHILD_WINDOW_CLOSED = "900";
COWindowComm.PARENT_WINDOW_CLOSED = "901";
var CheckConnection = /*#__PURE__*/(0, _createClass2["default"])(function CheckConnection(each, message, callback) {
  (0, _classCallCheck2["default"])(this, CheckConnection);
  this.each = each;
  this.message = message;
  this.callback = callback;
});
exports.CheckConnection = CheckConnection;
var Message = /*#__PURE__*/(0, _createClass2["default"])(function Message(status, message, data) {
  (0, _classCallCheck2["default"])(this, Message);
  this.message = message;
  this.status = status;
  this.data = data;
});
exports.Message = Message;
//# sourceMappingURL=COWindowComm.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/COWindowComm.js
// module id = 1098
// module chunks = 142